import axios from "axios";
import { toast } from "react-toastify";

function applyGlobalHeaders() {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");

  const guestId = localStorage.getItem("guest_id");
  const isGuest = localStorage.getItem("is_guest");

  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.common["x-access-token"] = token;
  } else if (isGuest && guestId) {
    axios.defaults.headers.common["x-guest-id"] = guestId;
  }
}

applyGlobalHeaders();

function getAuthHeaders() {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");

  const isGuest = localStorage.getItem("is_guest");
  const guestId = localStorage.getItem("guest_id");

  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
    headers["x-access-token"] = token;
  } else if (isGuest && guestId) {
    headers["x-guest-id"] = guestId;
  }

  return headers;
}

// axios.interceptors.response.use(null, (error) => {
//   console.log("🚨 AXIOS 401:", {
//     status: error.response?.status,
//     isGuest: localStorage.getItem("is_guest"),
//   });

//   console.log(error);
//   const expectedError =
//     error.response &&
//     error.response.status >= 400 &&
//     error.response.status < 500;

//   if (error.response?.data?.guestLimit) {
//     toast.info("Guest limit reached. Please login to continue.");
//     localStorage.removeItem("is_guest");
//     localStorage.removeItem("guest_id");
//     window.location.href = "/login";
//     return;
//   }

//   if (!expectedError) {
//     console.log(error);
//     toast.error("An unexpected error occurrred.");
//   }

//   return Promise.reject(error);
// });

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (error.response?.data?.guestLimit) {
      console.log("⚠ Guest limit reached");
      toast.info("Guest limit reached. Please login to continue.");
      localStorage.removeItem("is_guest");
      localStorage.removeItem("guest_id");
      window.location.replace("/login");
      return;
    }

    if (!expectedError) {
      toast.error("An unexpected error occurred.");
    }

    return Promise.reject(error);
  },
);

function setJwt(jwt) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
  axios.defaults.headers.common["x-access-token"] = jwt;
}

// A 401 normally means the session is gone: the token is dropped and the user
// is sent back to the login screen. But endpoints restricted by role answer
// 401 for perfectly valid sessions too — a normal user calling a super-admin
// endpoint, say — and treating that as an expired session logged people out of
// pages they were entitled to open. Those callers pass
// { allowUnauthorized: true } and deal with the response themselves.
function handleUnauthorized(response, options = {}) {
  if (response?.status !== 401) return response;

  const isGuest = localStorage.getItem("is_guest") === "true";
  if (isGuest || options.allowUnauthorized) return response;

  toast.error(response.message);
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  localStorage.setItem("sessiontimeout", true);
  window.location.href = "/login";
  return undefined;
}

async function getFetch(apiEndpoint, options) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  response = await response.json();
  return handleUnauthorized(response, options);
}

async function deleteFetch(apiEndpoint, options) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  response = await response.json();
  return handleUnauthorized(response, options);
}

async function postFetch(apiEndpoint, data, options) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
  });
  response = await response.json();
  return handleUnauthorized(response, options);
}

async function putFetch(apiEndpoint, data, options) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(data), // We send data in JSON format
  });
  response = await response.json();
  return handleUnauthorized(response, options);
}

export default {
  get: getFetch,
  post: postFetch,
  put: putFetch,
  delete: deleteFetch,
  setJwt,
};
